import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { GlobalService } from "../services/global.service";

@Injectable({
    providedIn: 'root' // en Angular 8 ya funciona
})

export class LoggerService
{
    private readonly prefix = '[IONINVM]';

    constructor(public global: GlobalService) { }

    private getCallerInfo(): string
    {
        const err = new Error();
        if (!err.stack) return 'unknown';

        const lines = err.stack.split('\n');

        // Línea 0 = Error
        // Línea 1 = getCallerInfo
        // Línea 2 = log
        // Línea 3 = quien llamó al logger
        if (lines.length >= 4)
        {
            return lines[3].trim();
        }

        return 'unknown';
    }

    /** Log solo en desarrollo */
    log(...args: any[]): void
    {
        if (this.global.debug)
        {
            // compat: no uses console.log.apply si no quieres; spread va bien en TS
            const caller = this.getCallerInfo();
            console.log(`[${caller}]`, ...args);
        }
    }

    /** Warn solo en desarrollo */
    warn(...args: any[]): void
    {
        if (this.global.debug)
        {
            const caller = this.getCallerInfo();
            console.warn(`[${caller}]`, ...args);
        }
    }

    /**
     * Error: por defecto LO DEJO SIEMPRE (también en prod),
     * porque suele ser útil ver errores reales.
     * Si quieres que en prod calle también, dime y lo cambio.
     */
    error(...args: any[]): void
    {
        const caller = this.getCallerInfo();
        console.error(`[${caller}]`, ...args);

    }

    /** Útil para trazar entradas/salidas */
    debug(tag: string, ...args: any[]): void
    {
        if (this.global.debug)
        {
            const caller = this.getCallerInfo();
            console.log(`[${caller}]`, ...args);

        }
    }
}